import { render } from "./audioWave.vue?vue&type=template&id=59dd5aca&scoped=true"
import script from "./audioWave.vue?vue&type=script&lang=js"
export * from "./audioWave.vue?vue&type=script&lang=js"

import "./audioWave.vue?vue&type=style&index=0&id=59dd5aca&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dd5aca"]])

export default __exports__